import React from "react";
import ProgressBar from "@ramonak/react-progress-bar";

import "./Skills.css";

function Skills() {
  return (
    <div className="skills-section">
      <div className="skills-container">
        <div className="skills-title">
          <h1 className="section-title">SKILLS</h1>
          <h3 className="section-subtitle">What I do</h3>
        </div>
        <ul className="skills-list">
          <div className="skills-set">
            <li className="skill">
              <div className="skill-container">
                <img
                  className="skill-image"
                  alt="skill"
                  src={`https://img.icons8.com/color/48/000000/javascript.png`}
                ></img>
                <h3 className="skill-title">{"JavaScript"}</h3>
              </div>
              <ProgressBar completed={90} isLabelVisible={false} />
            </li>
            <li className="skill">
              <div className="skill-container">
                <img
                  className="skill-image"
                  alt="skill"
                  src={`https://img.icons8.com/color/48/000000/html-5.png`}
                ></img>
                <h3 className="skill-title">{"HTML"}</h3>
              </div>
              <ProgressBar completed={90} isLabelVisible={false} />
            </li>
            <li className="skill">
              <div className="skill-container">
                <img
                  className="skill-image"
                  alt="skill"
                  src={`https://www.pngfind.com/pngs/m/150-1507248_image-library-stock-file-vue-js-logo-wikimedia.png`}
                ></img>
                <h3 className="skill-title">{"VUE"}</h3>
              </div>
              <ProgressBar completed={90} isLabelVisible={false} />
            </li>
            <li className="skill">
              <div className="skill-container">
                <img
                  className="skill-image"
                  alt="skill"
                  src={`https://img.icons8.com/officel/40/000000/react.png`}
                ></img>
                <h3 className="skill-title">{"React"}</h3>
              </div>
              <ProgressBar completed={90} isLabelVisible={false} />
            </li>
            <li className="skill">
              <div className="skill-container">
                <img
                  className="skill-image"
                  alt="skill"
                  src={`https://img.icons8.com/color/48/000000/redux.png`}
                ></img>
                <h3 className="skill-title">{"Redux"}</h3>
              </div>
              <ProgressBar completed={90} isLabelVisible={false} />
            </li>
          </div>
          <div className="skills-set">
             <li className="skill">
              <div className="skill-container">
                <img
                  className="skill-image"
                  alt="skill"
                  src={`https://banner2.cleanpng.com/20180815/xbk/kisspng-sass-logo-cascading-style-sheets-scalable-vector-g-codzero-cms-blog-tool-publishing-platform-5b74aaa0de6192.1715579115343725129109.jpg`}
                ></img>
                <h3 className="skill-title">{"SCSS"}</h3>
              </div>
              <ProgressBar completed={90} isLabelVisible={false} />
            </li>
            <li className="skill">
              <div className="skill-container">
                <img
                  className="skill-image"
                  alt="skill"
                  src={`https://img.icons8.com/color/48/000000/nodejs.png`}
                ></img>
                <h3 className="skill-title">{"Node.js"}</h3>
              </div>
              <ProgressBar completed={80} isLabelVisible={false} />
            </li>
            <li className="skill">
              <div className="skill-container">
                <img
                  className="skill-image"
                  alt="skill"
                  src={`https://img.icons8.com/color/firebase.png`}
                ></img>
                <h3 className="skill-title">{"Firebase"}</h3>
              </div>
              <ProgressBar completed={80} isLabelVisible={false} />
            </li>
            <li className="skill">
              <div className="skill-container">
                <img
                  className="skill-image"
                  alt="skill"
                  src={`https://img.icons8.com/color/452/bootstrap.png`}
                ></img>
                <h3 className="skill-title">{"Bootstrap"}</h3>
              </div>
              <ProgressBar completed={70} isLabelVisible={false} />
            </li>
            <li className="skill">
              <div className="skill-container">
                <img
                  className="skill-image"
                  alt="skill"
                  src={`https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Laravel.svg/1969px-Laravel.svg.png`}
                ></img>
                <h3 className="skill-title">{"Laravel"}</h3>
              </div>
              <ProgressBar completed={70} isLabelVisible={false} />
            </li>
          </div>
        </ul>
        <p className="other-languages">
          Furthermore I have experience with React Native, GraphQL, Git and
          TypeScript
        </p>
      </div>
    </div>
  );
}

export default Skills;
